import React from 'react';
import ModuleShell from '@/components/layout/ModuleShell';
import { useAuth } from '@/contexts/AuthContext';
import FinancePage from '@/pages/FinancePage';
import InvoicesPage from '@/pages/InvoicesPage';
import TrustAccountPage from '@/pages/TrustAccountPage';
import XeroExportPage from '@/pages/XeroExportPage';

export default function FinanceModule() {
  const { user } = useAuth();
  const isFinAdmin = ['mga_admin', 'platform_owner'].includes(user?.role);
  const tabs = [
    { id: 'overview', label: 'Overview', content: <FinancePage /> },
    { id: 'invoices', label: 'Invoices & Payments', content: <InvoicesPage /> },
    ...(isFinAdmin ? [
      { id: 'trust', label: 'Trust Account', content: <TrustAccountPage /> },
      { id: 'xero', label: 'Xero Export', content: <XeroExportPage /> },
    ] : []),
  ];

  return (
    <ModuleShell title="Finance" subtitle="Premium trust and financial reporting" tabs={tabs} />
  );
}
